import {toastr} from 'react-redux-toastr';
import {initialize} from 'redux-form';
import {
  getJsonAsync,
  postJsonAsync,
  putJsonAsync
} from 'shared/actions';
import {
  setErrorList
} from 'shared/error/actionTypes';
import {loadTournament} from '../actions';
import {
  displayDivisionInForm,
  setEventSelectedInState,
  setVirtualEventSelectedInState,
  displayNewDivision,
  cancelDivisionItemForm,
  hightlightSelectedEvent,
  highlightSelectedVirtualEvent,
  displayEvents,
  displayVirtualEvents,
  displayDivisions,
  setDivisionDisplayDefault
} from './actionTypes';

export const handleDivisionClick = divisionId => dispatch => {
  dispatch(setDivisionDisplayDefault(divisionId));
  dispatch(getJsonAsync(`division/${divisionId}`))
  .then(data => {
    dispatch(cancelDivisionItemForm());
    dispatch(displayDivisionInForm(divisionId));
    dispatch(initialize(`divisionItemForm`, data));
  });
};

export const validate = ({
    name,
    minAverage,
    maxAverage,
    minAge,
    maxAge
  }) => {

  let errors = {};

  if (!name){
    errors.name = 'Name is required';
  }

  if (!minAverage && minAverage !== 0) {
    errors.minAverage = 'Min Average is required';
  } else if (isNaN(Number(minAverage))) {
    errors.minAverage = 'Must be a valid number';
  } else if (Number(minAverage) < 0) {
    errors.minAverage = 'Must be zero or a greater number';
  } else if (Number(minAverage) > 9900) {
    errors.minAverage = 'Cannot be greater than 9900';
  } else if (!isNaN(Number(maxAverage)) && Number(minAverage) > Number(maxAverage)) {
    errors.minAverage = 'Min Average must be less than Max Average';
  }

  if (!maxAverage && minAverage !== 0) {
    errors.maxAverage = 'Max Average is required';
  } else if (isNaN(Number(maxAverage))) {
    errors.minAverage = 'Must be a valid number';
  } else if (Number(maxAverage) < 0) {
    errors.maxAverage = 'Must be zero or a greater number';
  } else if (Number(maxAverage) > 9900) {
    errors.maxAverage = 'Cannot be greater than 9900';
  }

  if (isNaN(Number(maxAge))) {
    errors.maxAge = 'Max Age Limit must be a valid number';
  } else if (Number(maxAge) > 999) {
    errors.maxAge = 'Max Age Limit must be less than 999'; 
  } 
  if (isNaN(Number(minAge))) {
    errors.minAge = 'Min Age Limit must be a valid number';
  } else if (Number(minAge) > 999) {
    errors.minAge = 'Min Age Limit must be less than 999';
  }else if (!isNaN(Number(maxAge)) && Number(minAge) > Number(maxAge)) {
    errors.minAge = 'Min Age Limit must be less than Max Age Limit';
  } 

  return errors;
};

export const handleSave = data => (dispatch, getState) => new Promise((resolve) => {
  const tournamentState = getState().tournament,
    {eventIdSelected, virtualEventIdSelected} = tournamentState.divisions,
    tournamentId = tournamentState.base.tournamentInfo.id;
  const averageBased = getState().tournament.divisions.selectedEventAverageBased;
  const ageBased = getState().tournament.divisions.selectedEventAgeBased;
  const genderBased = getState().tournament.divisions.selectedEventGenderBased;
  
  const bodyData = {
    ...data,
    ...{
      eventId: eventIdSelected,
      virtualEventId: virtualEventIdSelected
    },
    averageBased,
    ageBased,
    genderBased
  };
  const promise = data.id
    ? putJsonAsync('division', bodyData)
    : postJsonAsync('division', bodyData);

  dispatch(promise)
    .then(() => {
      toastr.success('Saved!', 'Division saved successfully.');
      if (eventIdSelected){
        dispatch(retrieveDivisionByEvent(eventIdSelected));
      } else {
        dispatch(retrieveDivisionByVirtualEvent(virtualEventIdSelected));
      }
      dispatch(loadTournament(tournamentId));
      resolve();
    })
    .catch(() => resolve());
});

export const handleCancel = () => dispatch => {
  dispatch(setErrorList([]));
  dispatch(cancelDivisionItemForm());
};

export const handeNewDivisionClick = () => dispatch => {
  dispatch(cancelDivisionItemForm());
  dispatch(displayNewDivision());
  dispatch(initialize(`divisionItemForm`, {displayDefault: true, averageBased: false, ageBased: false}));
};

export const handleEventClick = eventId => dispatch => {
  dispatch(setVirtualEventSelectedInState(null));
  dispatch(highlightSelectedVirtualEvent(null));
  dispatch(setEventSelectedInState(eventId));
  dispatch(hightlightSelectedEvent(eventId));
  dispatch(retrieveDivisionByEvent(eventId));
};

export const handleVirtualEventClick = virtualEventId => dispatch => {
  dispatch(setEventSelectedInState(null));
  dispatch(hightlightSelectedEvent(null));
  dispatch(setVirtualEventSelectedInState(virtualEventId));
  dispatch(highlightSelectedVirtualEvent(virtualEventId));
  dispatch(retrieveDivisionByVirtualEvent(virtualEventId));
};

export const retrieveDivisionsEvents = tournamentId => dispatch => {
  dispatch(getJsonAsync(`tournament/${tournamentId}/events`))
    .then(data => {
      dispatch(displayEvents(data));
      dispatch(setEventSelectedInState(null));
      dispatch(displayDivisions([]));
    });
};

export const retrieveDivisionVirtualEvents = tournamentId => dispatch => {
  dispatch(getJsonAsync(`tournament/${tournamentId}/virtualevents`))
    .then(virtualEvents => {
      dispatch(displayVirtualEvents(virtualEvents));
      dispatch(setVirtualEventSelectedInState(null));
      dispatch(displayDivisions([]));
    });
};

export const retrieveDivisionByEvent = eventId => dispatch => {
  dispatch(getJsonAsync(`event/${eventId}/divisions`))
    .then(data => dispatch(displayDivisions(data)));
};

export const retrieveDivisionByVirtualEvent = virtualEventId => dispatch => {
  dispatch(getJsonAsync(`virtualevent/${virtualEventId}/divisions`))
    .then(data => dispatch(displayDivisions(data)));
};


// WEBPACK FOOTER //
// ./src/features/tournament/divisions/actions.js